var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.87 28.87",
    id: "pinterest",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.87,
    height: 28.87,
    fill: "#ff3635",
    rx: 6.48,
    ry: 6.48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.45 16.82v.12a13.14 13.14 0 0 1-1.23 3.79 11.65 11.65 0 0 1-.95 1.42c0 .05-.08.12-.16.1s-.09-.1-.1-.17a12.11 12.11 0 0 1-.16-2.08c0-.9.14-1.21 1.3-6.08a.34.34 0 0 0 0-.2 3.43 3.43 0 0 1-.15-2.26c.52-1.66 2.41-1.79 2.74-.42.2.85-.33 2-.75 3.6C13.68 16 15.28 17 16.64 16s1.74-3.1 1.65-4.64c-.18-3.09-3.57-3.75-5.71-2.76-2.46 1.14-3 4.19-1.91 5.58.14.18.25.29.2.47s-.13.56-.21.84a.3.3 0 0 1-.44.2 2.52 2.52 0 0 1-1-.77 4.87 4.87 0 0 1 0-5.44 6.53 6.53 0 0 1 6.3-2.78 5.34 5.34 0 0 1 4.91 4.41 7.34 7.34 0 0 1-1.35 5.16c-1.6 2-4.19 2.11-5.39.9-.08-.17-.15-.24-.24-.35z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.d4fa711c828f0de924ea5e63326ae1de.svg";
export { ForwardRef as ReactComponent };